import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import SET_USER from './types';
import { fetchUser as _fetchUser } from '~/services/user';
export default {
  fetchUser: function () {
    var _fetchUser2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var commit, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              _context.prev = 1;
              _context.next = 4;
              return _fetchUser(this);

            case 4:
              user = _context.sent;
              commit(SET_USER, user);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.log(_context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 8]]);
    }));

    function fetchUser(_x) {
      return _fetchUser2.apply(this, arguments);
    }

    return fetchUser;
  }()
};